import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-accent text-white font-weight-bold" }, " Rekap Pembatalan Menu ", -1)
const _hoisted_3 = { class: "card-body px-0 py-0" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-dark text-white" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "Keterangan"),
    /*#__PURE__*/_createElementVNode("th", null, "Jumlah"),
    /*#__PURE__*/_createElementVNode("th", null, "Nominal"),
    /*#__PURE__*/_createElementVNode("th", null, "Aksi")
  ])
], -1)
const _hoisted_7 = {
  key: 0,
  class: "px-1 py-1"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    class: "text-center text-muted"
  }, "Belum ada data")
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "card-body"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Data masih kosong", -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          (_ctx.mutModalEmpty)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true),
          (!_ctx.mutModalEmpty)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cancelledRecap.result, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, _toDisplayString(item.keterangan), 1),
                    _createElementVNode("td", null, _toDisplayString(item.qty), 1),
                    _createElementVNode("td", null, _toDisplayString(item.nominal), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: _withModifiers(($event: any) => (_ctx.onClick(item)), ["prevent"])
                      }, "LIHAT", 8, _hoisted_11)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.cancelledRecap.error == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
      : _createCommentVNode("", true)
  ]))
}